var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-indicator"},[(_vm.showMessage)?_c('div',{staticClass:"overlay",class:{ 'overlay-content-mode' : _vm.mode === 'content', 'overlay-main-mode' : _vm.mode === 'main' }},[_c('t',{attrs:{"k":"generic.loading","raw":true}})],1):_vm._e()]):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }